var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ContractForm',{attrs:{"contract":_vm.contract},on:{"clear":_vm.clearForm}}),_c('Text',{attrs:{"contract":_vm.contract,"company":_vm.company,"companyObject":_vm.companyObject}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }